import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/permits")({
  component: PermitsLayout,
});

function PermitsLayout() {
  return <Outlet />;
}
